class InfiniteScroll {
  constructor() {
    this.loading = false;
    this.nextPageUrl = this.getNextPageUrl();
    
    if (!this.nextPageUrl) return;
    
    this.productGrid = document.querySelector('.collection .product-grid, ul.grid');
    this.sentinel = this.createSentinel();
    this.observer = new IntersectionObserver(this.onIntersect.bind(this), {
      rootMargin: '200px',
    });
    
    this.observer.observe(this.sentinel);
    this.hidePagination();
  }

  getNextPageUrl() {
    const nextLink = document.querySelector('a[href*="page="]:not(.pagination__item--current)');
    // More reliable: find the "next" pagination link
    const paginationNext = document.querySelector('.pagination .next a, a[href*="?page="], a[href*="&page="]');
    
    // Find next page link specifically
    const links = document.querySelectorAll('.pagination a');
    for (const link of links) {
      if (link.getAttribute('aria-label')?.toLowerCase().includes('next') || 
          link.classList.contains('pagination__item--next')) {
        return link.href;
      }
    }
    return null;
  }

  createSentinel() {
    const el = document.createElement('div');
    el.id = 'infinite-scroll-sentinel';
    el.style.height = '1px';
    
    const pagination = document.querySelector('.pagination');
    if (pagination) {
      pagination.parentNode.insertBefore(el, pagination);
    } else {
      this.productGrid?.parentNode.appendChild(el);
    }
    
    return el;
  }

  hidePagination() {
    const pagination = document.querySelector('.pagination');
    if (pagination) pagination.style.display = 'none';
  }

  async onIntersect(entries) {
    if (!entries[0].isIntersecting || this.loading || !this.nextPageUrl) return;
    
    this.loading = true;
    this.showLoader();
    
    try {
      const res = await fetch(this.nextPageUrl);
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      
      // Append new products
      const newProducts = doc.querySelectorAll('.collection .product-grid > *, ul.grid > li');
      newProducts.forEach(item => this.productGrid.appendChild(item));
      
      // Get next page URL from loaded page
      this.nextPageUrl = null;
      const nextLinks = doc.querySelectorAll('.pagination a');
      for (const link of nextLinks) {
        if (link.getAttribute('aria-label')?.toLowerCase().includes('next') || 
            link.classList.contains('pagination__item--next')) {
          this.nextPageUrl = link.href;
          break;
        }
      }
      
      if (!this.nextPageUrl) {
        this.observer.disconnect();
        this.sentinel.remove();
      }
    } catch (err) {
      console.error('Infinite scroll error:', err);
    } finally {
      this.loading = false;
      this.hideLoader();
    }
  }

  showLoader() {
    let loader = document.getElementById('infinite-scroll-loader');
    if (!loader) {
      loader = document.createElement('div');
      loader.id = 'infinite-scroll-loader';
      loader.innerHTML = '<div class="infinite-scroll-spinner"></div>';
      this.sentinel.parentNode.insertBefore(loader, this.sentinel);
    }
    loader.style.display = 'flex';
  }

  hideLoader() {
    const loader = document.getElementById('infinite-scroll-loader');
    if (loader) loader.style.display = 'none';
  }
}

document.addEventListener('DOMContentLoaded', () => new InfiniteScroll());